// start:react-app-polyfill
// these must be the first lines in src/index.js
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
// end:react-app-polyfill
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './app';
import { webLogPost } from './helpers/web-log';
import { store } from './store';

// Global uncaught error forwarding — fire-and-forget, disabled in local dev
window.addEventListener('error', (event) => {
  const { error, message, lineno, colno, filename } = event;
  webLogPost({
    attributes: {
      colno,
      lineno,
      name: error instanceof Error ? error.name : undefined,
      source: filename,
      stack: error instanceof Error ? error.stack : undefined,
    },
    level: 'error',
    message,
  });
});

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const { reason } = event;
  const message = reason instanceof Error ? reason.message : String(reason);
  webLogPost({
    attributes: {
      name: reason instanceof Error ? reason.name : undefined,
      stack: reason instanceof Error ? reason.stack : undefined,
    },
    level: 'error',
    message,
  });
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('#root')
);
